import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconResourceUrl } from 'src/assets/icons/ResourceUrl';
import { TruncatedTypography, TYPOGRAPHY_VARIANT } from 'src/components/TruncatedTypography';
import { PROMPT_ACTION } from 'src/data/prompt';

import { BaseMenuItem } from '../BaseMenuItem';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape().isRequired,
  onAction: PropTypes.func.isRequired,
};

const defaultProps = {
  className: '',
};

export const MenuItemUrl = ({ className, item, onAction }) => {
  const styles = useStyles();

  const handleClick = () => {
    onAction(PROMPT_ACTION.insertUrl, {
      item,
      url: item.content,
    });
  };

  return (
    <BaseMenuItem
      className={cx(styles.root, className)}
      item={item}
      onClick={handleClick}
      data-testid="urlPromptInstructionsMenuItem"
    >
      <IconResourceUrl className={styles.assetIcon} />

      <div className={styles.content}>
        {item.label && (
          <TruncatedTypography
            className={styles.label}
            variant={TYPOGRAPHY_VARIANT.medium14}
          >
            {item.label}
          </TruncatedTypography>
        )}

        <TruncatedTypography
          className={styles.body}
          variant={TYPOGRAPHY_VARIANT.regular12}
          title={item.content}
        >
          {item.subtitle && <span>{item.subtitle + ' • '}</span>} {item.content}
        </TruncatedTypography>
      </div>
    </BaseMenuItem>
  );
};

MenuItemUrl.propTypes = propTypes;
MenuItemUrl.defaultProps = defaultProps;
